import { TODAY } from '../../constants';
import { resolveUpdate } from './resolve';

export const createDealsSlice = (set) => ({
  // ── CRM / Affaires ──
  deals: [],
  setDeals: (suivant) => set((etat) => ({ deals: resolveUpdate(suivant, etat.deals) })),
  crmClients: [], // tous les clients (incl. prospects)
  setCrmClients: (suivant) =>
    set((etat) => ({ crmClients: resolveUpdate(suivant, etat.crmClients) })),
  dealNextActions: {}, // { [affaireId]: { type, date } } prochaine action prévue
  setDealNextActions: (suivant) =>
    set((etat) => ({ dealNextActions: resolveUpdate(suivant, etat.dealNextActions) })),
  dealTasks: [], // toutes les actions prévues (pour l'accueil "à relancer")
  setDealTasks: (suivant) => set((etat) => ({ dealTasks: resolveUpdate(suivant, etat.dealTasks) })),
  dealsLoaded: false,
  setDealsLoaded: (suivant) =>
    set((etat) => ({ dealsLoaded: resolveUpdate(suivant, etat.dealsLoaded) })),
  dealsView: 'table', // 'table' | 'kanban'
  setDealsView: (suivant) => set((etat) => ({ dealsView: resolveUpdate(suivant, etat.dealsView) })),
  dealsFilter: { q: '', statut: [], type: [], resp: [] }, // multi-sélection cumulable
  setDealsFilter: (suivant) =>
    set((etat) => ({ dealsFilter: resolveUpdate(suivant, etat.dealsFilter) })),
  dealsFilterOpen: null, // 'statut' | 'type' | 'resp' | null
  setDealsFilterOpen: (suivant) =>
    set((etat) => ({ dealsFilterOpen: resolveUpdate(suivant, etat.dealsFilterOpen) })),
  dealViews: [], // vues enregistrées (affaire_vues)
  setDealViews: (suivant) => set((etat) => ({ dealViews: resolveUpdate(suivant, etat.dealViews) })),
  dealViewsOpen: false,
  setDealViewsOpen: (suivant) =>
    set((etat) => ({ dealViewsOpen: resolveUpdate(suivant, etat.dealViewsOpen) })),
  quickTask: null, // null | { affaire_id, type, date, note } raccourci tâche
  setQuickTask: (suivant) => set((etat) => ({ quickTask: resolveUpdate(suivant, etat.quickTask) })),
  dealNewProspect: null, // null | { nom, origine, secteur } création prospect à la volée
  setDealNewProspect: (suivant) =>
    set((etat) => ({ dealNewProspect: resolveUpdate(suivant, etat.dealNewProspect) })),
  dealEdit: null, // édition inline tableau : { id, field, ... }
  setDealEdit: (suivant) => set((etat) => ({ dealEdit: resolveUpdate(suivant, etat.dealEdit) })),
  dealModal: null, // null | objet affaire en édition/création
  setDealModal: (suivant) => set((etat) => ({ dealModal: resolveUpdate(suivant, etat.dealModal) })),
  convertModal: null, // null | { affaire, phases:[…], skipped:[…], jiraKeyGlobal } — mapping avant conversion
  setConvertModal: (suivant) =>
    set((etat) => ({ convertModal: resolveUpdate(suivant, etat.convertModal) })),
  completeModal: null, // null | { act, noteCompletion } — validation d'une action
  setCompleteModal: (suivant) =>
    set((etat) => ({ completeModal: resolveUpdate(suivant, etat.completeModal) })),
  closeReasonModal: null, // null | { affaireId, newStatut, motif } — raison de clôture
  setCloseReasonModal: (suivant) =>
    set((etat) => ({ closeReasonModal: resolveUpdate(suivant, etat.closeReasonModal) })),
  draggedDealId: null, // id de l'affaire en cours de drag
  setDraggedDealId: (suivant) =>
    set((etat) => ({ draggedDealId: resolveUpdate(suivant, etat.draggedDealId) })),
  dealActivityList: [], // activités de l'affaire ouverte
  setDealActivityList: (suivant) =>
    set((etat) => ({ dealActivityList: resolveUpdate(suivant, etat.dealActivityList) })),
  activityForm: {
    type: 'Appel',
    date: '',
    etat: 'prevu',
    note: '',
  },
  setActivityForm: (suivant) =>
    set((etat) => ({ activityForm: resolveUpdate(suivant, etat.activityForm) })),
  activityEdit: null, // null | { id, type, date, etat, note } action en édition inline
  setActivityEdit: (suivant) =>
    set((etat) => ({ activityEdit: resolveUpdate(suivant, etat.activityEdit) })),
  crmYear: TODAY.getFullYear(), // année CRM (date de création) — number | 'all'
  setCrmYear: (suivant) => set((etat) => ({ crmYear: resolveUpdate(suivant, etat.crmYear) })),
});
